import React from "react";
import Chart from "react-apexcharts";

interface Props {
    title: string;
    chartData: any;
}

const LineChartWidget = ({ title, chartData }: Props) => {
    return (
        <div className="overflow-hidden">
            <div className="row mb-3 chart-header" style={{ borderBottom: "2px solid #ddd", paddingBottom: "10px" }}>
                <div className="col-12"><h5 className="text-center">{title}</h5></div>
            </div>
            <div className="col-12">
                {chartData && chartData.count > 0 ? (
                    <Chart options={chartData.options} series={chartData.series} type="line" height={380} />
                ) : (
                    <div className="text-center py-4">No Records Found</div>
                )}
            </div>
        </div>
    );
};

export default LineChartWidget;
